"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subtitle = void 0;
var _index = require("../../styles/index.js");
var _index2 = require("../Text/index.js");
var _styledComponents = _interopRequireWildcard(require("../../styled-components.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Subtitle = exports.Subtitle = (0, _styledComponents["default"])(_index2.Text).attrs({
  forwardedAs: 'h4',
  variant: 'bodySmall',
  semanticColor: 'textSubdued'
}).withConfig({
  displayName: "Subtitle",
  componentId: "sc-1wbyyl6-0"
})(["display:block;", ";"], function (props) {
  return props.$truncate && (0, _styledComponents.css)(["", ";"], (0, _index.textOverflow)());
});